{
  "breadcrumb": {
    "root": "BLIKS IO",
    "dashboard": "Mein Arbeitsumfeld",
    "recordingDashboard": "Aufnahme-Cockpit",
    "organization": "Organisationskataloge",
    "organigram": "Organigramm",
    "processes": "Prozesse",
    "departments": "Abteilungen",
    "myOrgFunctions": "Meine Funktionen",
    "functions": "Funktionen",
    "teams": "Teams",
    "systems": "Systeme",
    "externalContacts": "Externe Kontakte",
    "artifacts": "Unterlagen",
    "orgMembers": "Personen",
    "allProcesses": "Alle Prozesse",
    "processEditor": "Prozesseditor",
    "myTasks": "Meine Aufgaben",
    "organizationSettings": "Einstellungen",
    "dataSync": "Datenabgleich",
    "initialSetup": "Ersteinrichtung",
    "setupPending": "Einrichtung läuft",
    "seatOverrun": "Organisation gesperrt",
    "processMap": "Prozesslandkarte",
    "processChains": "Prozessketten",
    "systemLandscape": "Systemlandschaft",
    "admin": "Admin",
    "tenants": "Mandanten",
    "accounts": "Konten",
    "users": "Benutzer",
    "partnerContent": "Partner-Inhalte",
    "createProcesses": "Prozesse erstellen",
    "shadowSystems": "Schatten-Systeme",
    "departmentsBulkUpload": "Abteilungen Massenupload",
    "userManagement": "Benutzerverwaltung",
    "apps": "Apps",
    "auditLogs": "Audit-Protokolle",
    "recordingAnalytics": "Aufnahme-Analysen",
    "aiUsage": "KI-Nutzung",
    "partner": "Partner",
    "leads": "Leads",
    "tasks": "Aufgaben",
    "helpCenter": "Kundenservice",
    "supportTickets": "Support-Tickets"
  },
  "notifications": {
    "title": "Benachrichtigungen",
    "empty": "Keine Benachrichtigungen"
  }
}
